import React from 'react';
import { Form } from 'react-bootstrap';
import { DataContext } from './DataContextProvider.js';

export default function SelectSplitMetric({ metric }) {
  const dataContext = React.useContext(DataContext);
  const onChangeMetric = event => {
    const split = event.target.value;
    if (split !== dataContext.split) {
      dataContext.setSplit(event.target.value);
    }
  }

  if (dataContext.split === 'source' && metric && metric !== 'page_views') {
    dataContext.setSplit('');
  }

  return (
    <Form>
      <Form.Control as="select" size="sm" defaultValue={dataContext.split} onChange={onChangeMetric}>
        <option value="">Totals</option>
        {metric === 'page_views' && <option value="source">by Traffic Source</option>}
        <option value="languages">by Computer Language</option>
        <option value="human_languages">by Human Language</option>
        <option value="products">by Product</option>
        <option value="teams">by Team</option>
      </Form.Control>
    </Form>
  );   
}
